var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "observer" },
    [
      _vm.modal
        ? _c("modal-assinatura", {
            attrs: {
              titulo: "Assinar Ofício de Cancelamento de Cláusula Resolutiva",
              texto:
                "Para realizar a assinatura do ofício de cancelamento de cláusula resolutiva é necessário informar a senha do seu certificado digital. Ao finalizar, o documento será assinado."
            },
            on: {
              closeModal: function($event) {
                return _vm.closeModal()
              },
              callbackSucesso: _vm.callbackModalAssinatura
            }
          })
        : _vm._e(),
      _c("div", { staticClass: "container-cadastro" }, [
        _c(
          "div",
          { attrs: { id: "passos" } },
          [
            _c(
              "el-steps",
              {
                attrs: {
                  active: _vm.passoAtivo,
                  "finish-status": "success",
                  simple: "simple"
                }
              },
              [
                _vm.isValidacao === false
                  ? _c("el-step", { attrs: { title: "Informar dados" } })
                  : _vm._e(),
                _vm.isValidacao === false
                  ? _c("el-step", { attrs: { title: "Editar Oficio" } })
                  : _vm._e(),
                _c("el-step", {
                  attrs: {
                    title: "Confirmar dados",
                    status: "naoPrecisaAparecerSucess"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { attrs: { id: "corpo" } },
          [
            _vm.passoAtivo === 1 && _vm.isValidacao === false
              ? _c("informar-dados", {
                  attrs: { despacho: _vm.despacho },
                  on: {
                    atualizarListaCartorios: _vm.atualizarListaCartorios,
                    atualizarAnexos: _vm.atualizarAnexos,
                    changeInteiroTeor: _vm.changeInteiroTeor
                  }
                })
              : _vm._e(),
            _vm.passoAtivo === 2
              ? _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("app-label", {
                              staticClass: "input-text-editor",
                              attrs: { label: "Despacho" }
                            }),
                            _c("app-editor-texto", {
                              ref: "editorTexto",
                              staticClass: "input",
                              class: { erro: errors.length },
                              on: { onTextChange: _vm.onTextChange },
                              model: {
                                value:
                                  _vm.despacho.tituloDespacho.oficioCcrDTO
                                    .textoOficio,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.despacho.tituloDespacho.oficioCcrDTO,
                                    "textoOficio",
                                    $$v
                                  )
                                },
                                expression:
                                  "despacho.tituloDespacho.oficioCcrDTO.textoOficio"
                              }
                            }),
                            _c("span", { staticClass: "help erro" }, [
                              _vm._v(_vm._s(errors[0]))
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1467868048
                  )
                })
              : _vm._e(),
            _vm.passoAtivo === 3
              ? _c("confirmar-dados", {
                  attrs: {
                    oficios: _vm.oficios,
                    idProcesso: _vm.processo.id,
                    despacho: _vm.despacho
                  },
                  on: {
                    changeRadio: _vm.changeRadio,
                    getBytesPdf: _vm.getBytesPdf
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _c("app-buttons-cadastro", {
        attrs: {
          isPrimeiroPasso: false,
          isUltimoPasso: _vm.ultimoPasso,
          showButtonSalvar: !_vm.ultimoPasso,
          showButtonDownload: _vm.ultimoPasso,
          showButtonCancelar: false,
          showButtonProximo: !_vm.ultimoPasso
        },
        on: {
          proximo: _vm.proximo,
          salvar: _vm.salvar,
          voltar: _vm.voltar,
          finalizar: _vm.assinarOficio,
          download: _vm.download
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b9e85bb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b9e85bb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/oficio/EmissaoOficio.vue
// module id = null
// module chunks = 